import { Reveal } from "@/components/Reveal";
import { ArrowRight } from "lucide-react";

const CtaSection = () => (
  <section data-testid="cta-section" className="marble-bg relative overflow-hidden py-32 lg:py-48">
    <svg className="pointer-events-none absolute -right-32 top-1/2 h-[560px] w-[560px] -translate-y-1/2 opacity-[0.12]" viewBox="0 0 200 200" fill="none" aria-hidden="true">
      <circle cx="100" cy="100" r="98" stroke="#C19D60" strokeWidth="0.6" />
      <circle cx="100" cy="100" r="70" stroke="#C19D60" strokeWidth="0.4" />
      <circle cx="100" cy="100" r="42" stroke="#C19D60" strokeWidth="0.3" />
    </svg>

    <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
      <Reveal className="max-w-3xl">
        <p className="mb-8 flex items-center gap-4 text-[11px] font-medium uppercase tracking-[0.4em] text-[#C19D60]">
          <span className="h-px w-12 bg-[#C19D60]/60" /> Il prossimo passo
        </p>
        <h2 data-testid="cta-headline" className="font-display text-5xl font-medium leading-[1.05] tracking-tight sm:text-6xl lg:text-7xl">
          Porta il tuo locale<br />nel <span className="gold-text italic">futuro.</span>
        </h2>
        <p className="mt-8 max-w-lg text-base font-light leading-relaxed text-[#A3A3A3]">
          Raccontaci cosa vuoi migliorare. Studieremo insieme la soluzione più adatta alla tua attività.
        </p>
        <div className="mt-12 flex flex-wrap items-center gap-6">
          <a
            href="#contatti"
            data-testid="cta-quote-btn"
            className="group relative overflow-hidden rounded-[5px] bg-[#C19D60] px-10 py-4 text-[12px] font-semibold uppercase tracking-[0.22em] text-[#050505]"
          >
            <span className="absolute inset-0 origin-left scale-x-0 bg-[#E5CAA4] transition-transform duration-500 ease-out group-hover:scale-x-100" />
            <span className="relative flex items-center gap-3">
              Richiedi un preventivo <ArrowRight size={15} className="transition-transform duration-500 group-hover:translate-x-1" />
            </span>
          </a>
          <a
            href="#contatti"
            data-testid="cta-contact-btn"
            className="border-b border-[#C19D60]/40 pb-1 text-[12px] font-medium uppercase tracking-[0.22em] text-[#E5CAA4] transition-colors duration-500 hover:border-[#C19D60] hover:text-[#F8F5F0]"
          >
            Contattaci
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CtaSection;
